<template>
	<div
		class="row"
	>
		<div class="col-12 mb-4 ">
			<div class="title mb-2">
				2. Необходимые документы
			</div>
			<documents
				ref="documents"
				:order="order.data"
				:documents="documents"
			/>
		</div>
		<div class="col-12 order-7 d-flex justify-content-start" @click="submitHandler">
			<slot name="footer" />
		</div>
	</div>
</template>

<script>
import Documents from '~/components/panels/formulate/components/documents/Documents.vue';
import { DOCUMENTS_VERIFICATION_TYPES } from '~/utils/dictionaries';

export default {
	name: 'SecondStep',
	components: { Documents },
	provide() {
		return {
			setDocuments: (slug, val) => {
				this.documents[slug] = { ...val };
			},
		};
	},
	inject: ['person'],
	props: {
		order: {
			type: Object,
			default: () => {},
		},
		block: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			documents_verifications_types: DOCUMENTS_VERIFICATION_TYPES,
			documents: {
				snils: {},
				passport: {},
				education: {},
				changingFIO: {},
			},
		};
	},
	computed: {
		productsWithAdmission() {
			return this.order.data.products.filter(
				(p) => p.documents_verification_type === this.documents_verifications_types.ADMISSION,
			);
		},
	},
	watch: {
		'documents.education.noEducation': {
			handler(val) {
				this.$emit('changeNoEducation', val);
			},
		},
	},
	methods: {
		async syncSimpleData() {
			await this.$api.syncPersonOnPayment(this.person.personData?.order_hash);
		},
		async submitHandler(event, submit = true, step) {
			const targetElement = event.target;
			if (targetElement?.id === 'submit' || submit) {
				try {
					let formData = new FormData();

					formData = this.createFormData(this.documents.education);

					formData = this.createFormData(this.documents.passport, formData);
					formData = this.createFormData(this.documents.changingFIO, formData);
					formData = this.createFormData(this.documents.snils, formData);

					await this.$api.setStudentDocs(this.person.personData?.order_hash, formData);

					await this.syncSimpleData();
					this.$emit('submit', null, step);
				} catch (e) {
					console.log(e);
				}
			}
		},
		createFormData(data, oldFormData = null) {
			const newData = {};
			Object.assign(newData, data);
			let formData = new FormData();
			if (oldFormData) formData = oldFormData;
			Object.keys(newData).forEach((key) => {
				if (newData[key]
					&& (!(newData[key] instanceof Object || Array.isArray(newData[key]))
						|| newData[key] instanceof File)) {
					formData.append(`values[${key}]`, newData[key]);
				} else if ('fileList' in newData[key]) {
					if (newData[key].files.length === 0) {
						formData.append(`values[${key}]`, null);
					} else if (newData[key].files[0].file instanceof File) {
						formData.append(`values[${key}]`, newData[key].files[0].file);
					}
				}
			});

			return formData;
		},
		handleChangeOrder(order) {
			this.$emit('handleChangeOrder', order);
		},
		changeStatus(status) {
			this.$emit('changeStatus', status);
		},
	},
};

</script>

<style scoped lang="scss">

</style>
